import React, { useState } from "react";
import About1 from "../../assets/images/about/02.jpg";
import AgencySvg from "../svg/Agency";
import OpneModal from "../modal/OpneModal";
const VideoSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <section className="about-section">
        <div className="container">

          <div className="row justify-content-center text-center mb-2">
            <div className="col-lg-8 col-md-12">
              <div className="theme-title">
                <h6 className="text-center mb-2" style={{ textAlign: "center" }}>Watch Our Video</h6>
                <h2 className="mb-2">Discover more about us.</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 position-relative">
              <img
                style={{ height: "600px", width: "100%" }}
                src={About1}
                className="img-fluid rounded img-filter"
                alt="Img1"
              />
              <div className="round-text cursor-pointer" onClick={openModal}>
                <AgencySvg label={" Watch Video Now • Watch Video Now •"} icon={"las la-play"} />
              </div>
            </div>
          </div>
        </div>
        <OpneModal isOpen={isOpen} closeModal={closeModal} />
      </section>
    </>
  );
};

export default VideoSection;